<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationKey) }">
    <label :for="name"><span v-if="isRequired">*</span> {{ label }}</label>
    <textarea v-if="type === 'textarea'"
              class="form-control"
              :id="name"
              :value="value"
              :placeholder="label"
              :name="name"
              v-validate="validators"
              :data-vv-as="label"
              v-on:input="$emit('input', $event.target.value)"
              v-bind="$attrs"
    />
    <input v-else
           :type="type"
           class="form-control"
           :id="name"
           :value="value"
           :placeholder="label"
           :name="name"
           v-validate="validators"
           :data-vv-as="label"
           v-on:input="$emit('input', $event.target.value)"
           v-bind="$attrs"
    />
    <span v-show="errors.has(validationKey)" class="help-block ">{{ errors.first(validationKey) }}</span>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    validationScope: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
    },
    validators: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    isRequired() {
      if (this.validators) {
        if (typeof this.validators === 'string') {
          return this.validators.includes('required');
        } else if (this.validators.required) {
          return true;
        }
      }
    },
    validationKey() {
      if (this.validationScope) {
        return `${this.validationScope}.${this.name}`;
      } else {
        return this.name;
      }
    },
  },
  inject: {
    $validator: '$validator'
  },
}
</script>



// WEBPACK FOOTER //
// FormInput.vue?39dd7f22